import { Stack, styled } from '@mui/material';

import { COLORS } from '../../../configs/colors';

export const StyledMobileWrapper = styled(Stack)`
  flex: 1;
  flex-direction: row;
  padding: 7px;
  margin-left: -10px;
  background-color: ${COLORS.SubtleBlue};
`;

export const MiddleColumnWrapper = styled(Stack)`
  flex: 2;
  align-items: flex-start;
  margin-left: 15px;
`;

export const RightColumnWrapper = styled(Stack)`
  flex: 1;
  align-items: flex-end;
  margin-right: 10px;
`;

export const OuterWrapper = styled(Stack)`
  flex-direction: row;
  align-items: center;
`;

export const IconWrapper = styled(Stack)`
  margin-right: 3px;
`;

export const PriorityChipWrapper = styled(Stack)`
  max-width: 60px;
  max-height: 20px;
  margin-bottom: 10px;
`;